export const setMaintenanceCategory = (facility: any, value: boolean) => {
  facility.maintenanceEnabled = value;
}